import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import AnalyticsWrapper from "./AnalyticsWrapper";

const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    AnalyticsWrapper.trackPageView(location.pathname);
  }, [location]);

  return null;
};

export default TrackPageView;